import styled from '@emotion/styled';

import { su } from '../../theme/functions/su';

export const Circle = styled.div`
  flex: 0 0 ${su(1)};
  width: ${su(1)};
  height: ${su(1)};
  background-color: hsl(${(props) => props.hue}, 75%, 50%);
  border: 1px solid hsl(${(props) => props.hue}, 75%, 45%);
  border-radius: 50%;
`;
